import React from "react";
import { motion } from "framer-motion";
import { Clock, CalendarCheck2, Wallet, ShieldCheck } from "lucide-react";

const items = [
  { icon: Clock, label: "Cash offers within 48 hours" },
  { icon: CalendarCheck2, label: "Close in as little as 14 days" },
  { icon: Wallet, label: "We cover standard closing costs" },
  { icon: ShieldCheck, label: "No agent fees. No commissions. Ever." },
];

const PromiseBar = () => {
  return (
    <section
      id="promise"
      className="relative"
      style={{ background: "#122B20", color: "#FAF7F2" }}
      data-testid="promise-bar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 md:py-14">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, ease: "easeOut", staggerChildren: 0.08 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10"
        >
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.08 * i, ease: "easeOut" }}
                className="flex items-start gap-3 md:gap-4"
                data-testid={`promise-item-${i}`}
              >
                <div className="shrink-0 mt-0.5">
                  <Icon size={22} color="#C6A15B" strokeWidth={1.5} />
                </div>
                <p
                  className="font-body text-sm md:text-[0.95rem]"
                  style={{
                    color: "#FAF7F2",
                    lineHeight: 1.5,
                    letterSpacing: "0.005em",
                  }}
                >
                  {it.label}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
      <div
        className="absolute inset-x-0 bottom-0 h-px"
        style={{ background: "rgba(198,161,91,0.3)" }}
      />
    </section>
  );
};

export default PromiseBar;
